export const BASE_URL = process.env.REACT_APP_API_URL || 'https://veloclik-inte-ws.velogik.com/api/1.0/';
export const API_KEY = process.env.REACT_APP_API_KEY || '9qju9zyMVKVMQHp9B3p43k88';
export const TIMEOUT = 100000000; // Usefull for the sync process between Veloclik and Velocare
export const PWD_SEED = process.env.REACT_APP_PWD_SEED || '4xV~v#447nD^dHV';
